<template>
  <div class="dialog1">
    <el-dialog 
      :title="dialog1.title" 
      :visible.sync="dialog1.show"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      :before-close="closeDialog"
      width="70%"
      center
      v-if="dialog1.show"
    >
      <!-- 步骤条 -->
      <el-steps :active="currentStep" finish-status="success" style="margin-bottom: 20px;">
        <el-step title="选择房屋" description="仅可选择一套未出租的房屋"></el-step>
        <el-step title="选择租户" description="选择/新增一个租户信息"></el-step>
        <el-step title="填写租赁信息" description="完善租赁详情并提交"></el-step>
      </el-steps>

      <!-- 步骤1：选择房屋（未出租） -->
      <div v-if="currentStep === 1" class="step-content">
        <el-form ref="houseForm" label-width="100px">
          <el-form-item label="房屋筛选：">
            <el-input v-model="houseSearch.address" placeholder="请输入区域筛选房屋" style="width: 300px;"></el-input>
            <el-input v-model="houseSearch.roomNum" placeholder="请输入房间号" style="width: 300px; margin-left: 10px;"></el-input>
            <el-button type="primary" @click="getUnRentHouseList" style="margin-left: 10px;">查询</el-button>
            <el-button @click="resetHouseSearch" style="margin-left: 10px;">重置</el-button>
          </el-form-item>
          
          <!-- 房屋列表 -->
          <el-table 
            :data="unRentHouseList" 
            border 
            style="width: 100%; margin-top: 10px;"
            @row-click="handleHouseRowClick"
          >
            <el-table-column prop="houseid" label="房屋ID" width="180"></el-table-column>
            <el-table-column prop="address" label="区域"  width="180"></el-table-column>
            <el-table-column prop="building" label="楼栋号"  width="180"></el-table-column>
            <el-table-column prop="roomNum" label="房间号" width="180"></el-table-column>
            <el-table-column prop="roomSquare" label="面积(㎡)" width="180"></el-table-column>
            <el-table-column prop="price" label="租金(元/月)" width="180"></el-table-column>
            <el-table-column prop="status" label="状态" width="180">
              <template slot-scope="scope">
                <el-tag type="success">未出租</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="212">
              <template slot-scope="scope">
                <el-button 
                  type="primary" 
                  size="big" 
                  @click="handleSelectHouse(scope.row)"
                  :type="isHouseSelected(scope.row) ? 'success' : 'primary'"
                >
                  {{ isHouseSelected(scope.row) ? '已选中' : '选中' }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>

          <!-- 选中信息展示 -->
          <div class="selected-house-info" style="margin-top:10px;padding:10px;border:1px solid #e6e6e6;background-color:#f8f8f8;">
            <span v-if="selectedHouse.id" style="color: #20a0ff; font-weight: bold;">
              ✅ 已选中房屋：{{selectedHouse.address}} - {{selectedHouse.roomNum}}（租金：{{selectedHouse.price}}元/月）
            </span>
            <span v-else style="color:#f56c6c;">
              ⚠️ 请选择一套未出租的房屋
            </span>
          </div>

          <div class="step-btn" style="margin-top: 20px; text-align: right;">
            <el-button @click="onCancal">取消</el-button>
            <el-button 
              type="primary" 
              @click="toNextStep"
              :disabled="!selectedHouse.id"
            >
              下一步（选择租户）
            </el-button>
          </div>
        </el-form>
      </div>

      <!-- 步骤2：选择租户 -->
      <div v-if="currentStep === 2" class="step-content">
        <el-form ref="tenantForm" label-width="100px">
          <el-form-item label="租户筛选：">
            <el-input v-model="tenantSearch.tenantname" placeholder="请输入租户名称筛选" style="width: 300px;"></el-input>
            <el-button type="primary" @click="getTenantList" style="margin-left: 10px;">查询</el-button>
            <el-button @click="resetTenantSearch" style="margin-left: 10px;">重置</el-button>
            <el-button type="success" @click="showAddTenantDialog = true" style="margin-left: 10px;">新增租户</el-button>
          </el-form-item>
          
          <!-- 租户表格 -->
          <el-table 
            :data="tenantList" 
            border 
            style="width: 100%; margin-top: 10px;"
            @row-click="handleTenantRowClick"
          >
            <el-table-column prop="tenantid" label="租户ID" width="240"></el-table-column>
            <el-table-column prop="tenantname" label="公司名称" width="340"></el-table-column>
            <el-table-column prop="contact" label="联系人" width="290"></el-table-column>
            <el-table-column prop="contactphone" label="联系电话" width="130"></el-table-column>
            <el-table-column label="操作" width="240">
              <template slot-scope="scope">
                <el-button 
                  type="primary" 
                  size="small" 
                  @click="handleSelectTenant(scope.row)"
                  :type="isTenantSelected(scope.row) ? 'success' : 'primary'"
                >
                  {{ isTenantSelected(scope.row) ? '已选中' : '选中' }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>

          <div class="selected-tenant-info" style="margin-top:10px;padding:10px;border:1px solid #e6e6e6;background-color:#f8f8f8;">
            <span v-if="selectedTenant.id" style="color: #20a0ff; font-weight: bold;">
              ✅ 已选中租户：{{selectedTenant.tenantname}}（联系人：{{selectedTenant.contact}}，电话：{{selectedTenant.contactphone}}）
            </span>
            <span v-else style="color:#f56c6c;">
              ⚠️ 请选择或新增一个租户
            </span>
          </div>

          <div class="step-btn" style="margin-top: 20px; text-align: right;">
            <el-button @click="toPrevStep">上一步</el-button>
            <el-button 
              type="primary" 
              @click="toNextStep"
              :disabled="!selectedTenant.id"
            >
              下一步（填写租赁信息）
            </el-button>
          </div>
        </el-form>

        <!-- 新增租户弹窗 -->
        <el-dialog title="新增租户" v-model="showAddTenantDialog" width="500px">
          <el-form ref="addTenantForm" :model="newTenant" label-width="100px" :rules="tenantRules">
            <el-form-item label="公司名称：" prop="tenantname">
              <el-input v-model="newTenant.tenantname"></el-input>
            </el-form-item>
            <el-form-item label="联系人：" prop="contact">
              <el-input v-model="newTenant.contact"></el-input>
            </el-form-item>
            <el-form-item label="联系电话：" prop="contactphone">
              <el-input v-model="newTenant.contactphone"></el-input>
            </el-form-item>
          </el-form>
          <template #footer>
            <el-button @click="showAddTenantDialog = false">取消</el-button>
            <el-button type="primary" @click="addTenant">保存</el-button>
          </template>
        </el-dialog>
      </div>

      <!-- 步骤3：填写租赁信息 -->
      <div v-if="currentStep === 3" class="step-content">
        <el-form 
          ref="leaseForm" 
          :model="formData"  
          :rules="formRules"
          label-width="140px" 
          style="margin:10px;width:auto;"
        >
          <!-- 第一行：房屋信息 -->
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="区域：" prop="address">
                <el-input v-model="formData.address" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="房间号：" prop="roomNum">
                <el-input v-model="formData.roomNum" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="租金(元/月)：" prop="price">
                <el-input v-model="formData.price" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 第二行：租户信息 -->
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="公司名称：" prop="tenantname">
                <el-input v-model="formData.tenantname" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="联系人：" prop="contact">
                <el-input v-model="formData.contact" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="联系电话：" prop="contactphone">
                <el-input v-model="formData.contactphone" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 第三行：租赁基础信息 -->
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="租赁开始日期：" prop="startdate" required>
                <el-date-picker
                  v-model="formData.startdate"
                  type="date"
                  placeholder="请选择开始日期"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  style="width: 100%;"
                  :editable="false"
                  @change="handleStartDateChange"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="租赁结束日期：" prop="enddate" required>
                <el-date-picker
                  v-model="formData.enddate"
                  type="date"
                  placeholder="请选择结束日期"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  style="width: 100%;"
                  :editable="false"
                  :disabled-date="disabledEndDate"
                  @change="handleEndDateChange"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="租赁月数：" prop="rentmounthnum">
                <el-input 
                  v-model="formData.rentmounthnum" 
                  type="number" 
                  min="1" 
                  placeholder="自动计算"
                  :disabled="true"
                >
                  <template slot="append">月</template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 第四行：押金和支付方式 -->
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="押金（元）：" prop="deposit" required>
                <el-input 
                  v-model="formData.deposit" 
                  type="number" 
                  min="0" 
                  placeholder="请输入押金金额"
                >
                  <template slot="append">元</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="租金支付方式：" prop="rentalsituation" required>
                <el-select 
                  v-model="formData.rentalsituation" 
                  placeholder="请选择支付方式" 
                  style="width: 100%;"
                  @change="handlePaymentMethodChange"
                >
                  <el-option label="月付" value="月付"></el-option>
                  <el-option label="季付" value="季付"></el-option>
                  <el-option label="半年付" value="半年付"></el-option>
                  <el-option label="年付" value="年付"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="本次是否付清：" prop="isfullypaid">
                <el-radio-group v-model="formData.isfullypaid">
                  <el-radio label="是">是</el-radio>
                  <el-radio label="否">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 第五行：本次租金信息 -->
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="本次租金日期：" prop="currentrentaldate" required>
                <el-date-picker
                  v-model="formData.currentrentaldate"
                  type="date"
                  placeholder="请选择租金日期"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  style="width: 100%;"
                  :editable="false"
                  @change="handleCurrentRentalDateChange"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="本次租金金额（元）：" prop="currentrentalamount" required>
                <el-input 
                  v-model="formData.currentrentalamount" 
                  type="number" 
                  min="0" 
                  placeholder="请输入租金金额"
                  @input="handleCurrentRentalAmountChange"
                >
                  <template slot="append">元</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="欠款金额（元）：" prop="arrears">
                <el-input 
                  v-model="formData.arrears" 
                  type="number" 
                  min="0" 
                  placeholder="欠款金额"
                  :disabled="formData.isfullypaid === '是'"
                >
                  <template slot="append">元</template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 第六行：下次租金信息 -->
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="下次支付日期：" prop="nextrentpaydate">
                <el-date-picker
                  v-model="formData.nextrentpaydate"
                  type="date"
                  placeholder="自动计算或手动选择"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  style="width: 100%;"
                  :editable="false"
                  :disabled="isNextDateAutoCalculated"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="下次支付金额（元）：" prop="nextrentamount">
                <el-input 
                  v-model="formData.nextrentamount" 
                  type="number" 
                  min="0" 
                  placeholder="默认等于本次租金金额"
                  @input="handleNextRentalAmountChange"
                >
                  <template slot="append">元</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <!-- 手动计算下次支付日期按钮 -->
              <el-form-item label-width="0">
                <el-button 
                  type="primary" 
                  @click="calculateNextPayment"
                  :disabled="!canCalculateNextPayment"
                  style="margin-top: 32px;"
                >
                  重新计算下次支付日期
                </el-button>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 第七行：备注 -->
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="备注：" prop="context">
                <el-input 
                  v-model="formData.context" 
                  type="textarea" 
                  :rows="4" 
                  placeholder="请输入备注信息"
                  maxlength="500"
                  show-word-limit
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item class="text_right">
            <el-button @click="toPrevStep">上一步</el-button>
            <el-button type="primary" @click="onSubmit">提交租赁信息</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import leaseApi from '../api/leaseinfo.js'
import houseApi from '../api/house.js'
import tenantApi from '../api/tenant.js'

export default {
  name: 'leaseinfoadd-dialog',
  props: {
    dialog1: {
      type: Object,
      default: () => ({
        title: '新增租赁信息',
        show: false
      })
    }
  },
  computed: {
    // 是否可以计算下次支付日期
    canCalculateNextPayment() {
      return this.formData.currentrentaldate && 
             this.formData.rentalsituation && 
             this.formData.currentrentalamount
    },
    
    // 下次支付日期是否为自动计算
    isNextDateAutoCalculated() {
      // 如果当前租金日期或支付方式发生变化，则自动计算
      return this.canCalculateNextPayment
    }
  },
  watch: {
    'dialog1.show'(newVal) {
      if (newVal) {
        this.resetFormData()
        this.getUnRentHouseList()
        this.getTenantList()
      }
    },
    // 监听是否付清变化
    'formData.isfullypaid'(newVal) {
      if (newVal === '是') {
        this.formData.arrears = '0'
      }
    }
  },
  data () {
    // 自定义校验规则：结束日期不能早于开始日期
    const validateEndDate = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请选择租赁结束日期'))
        return
      }
      
      if (!this.formData.startdate) {
        callback()
        return
      }
      
      const startDate = new Date(this.formData.startdate)
      const endDate = new Date(value)
      
      if (endDate < startDate) {
        callback(new Error('租赁结束日期不能早于开始日期'))
      } else {
        callback()
      }
    }
    
    return {
      currentStep: 1,
      houseSearch: { address: '', roomNum: '' },
      unRentHouseList: [],
      selectedHouse: { id: null, address: '', roomNum: '', price: '' },
      tenantSearch: { tenantname: '' },
      tenantList: [],
      selectedTenant: { id: null, tenantname: '', contact: '', contactphone: '' },
      showAddTenantDialog: false,
      newTenant: { tenantname: '', contact: '', contactphone: '' },
      formData: {
        address: '',
        roomNum: '',
        price: '',
        tenantname: '',
        contact: '',
        contactphone: '',
        startdate: '',
        enddate: '',
        deposit: '',
        rentalsituation: '',
        rentmounthnum: '',
        currentrentaldate: '',
        currentrentalamount: '',
        isfullypaid: '是', // 默认是付清的
        arrears: '0',
        nextrentpaydate: '',
        nextrentamount: '',
        context: '',
        // 标记下次支付金额是否被手动修改过
        isNextAmountModified: false
      },
      tenantRules: {
        tenantname: [{ required: true, message: '请输入公司名称', trigger: 'blur' }],
        contact: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
        contactphone: [{ required: true, message: '请输入联系电话', trigger: 'blur' }]
      },
      formRules: {
        startdate: [{ required: true, message: '请选择租赁开始日期', trigger: 'change' }],
        enddate: [
          { required: true, message: '请选择租赁结束日期', trigger: 'change' },
          { validator: validateEndDate, trigger: 'change' }
        ],
        deposit: [{ required: true, message: '请输入押金金额', trigger: 'blur' }],
        rentalsituation: [{ required: true, message: '请选择租金支付方式', trigger: 'change' }],
        currentrentaldate: [{ required: true, message: '请选择本次租金日期', trigger: 'change' }],
        currentrentalamount: [{ required: true, message: '请输入本次租金金额', trigger: 'blur' }],
        isfullypaid: [{ required: true, message: '请选择是否付清', trigger: 'change' }]
      }
    }
  },
  mounted () {
    if (this.dialog1.show) {
      this.getUnRentHouseList()
      this.getTenantList()
    }
  },
  methods: {
    // ===================== 房屋相关方法 =====================
    async getUnRentHouseList () {
      try {
        const res = await houseApi.getHouseListByRoomNum(this.houseSearch)
        
        let houseData = []
        if (Array.isArray(res.data)) {
          houseData = res.data
        } else if (res.data && Array.isArray(res.data.data)) {
          houseData = res.data.data
        } else if (res.data && res.data.records) {
          houseData = res.data.records
        } else if (res.data && res.data.list) {
          houseData = res.data.list
        }
        
        this.unRentHouseList = houseData.map(item => {
          if (item.id) return item
          return {
            ...item,
            id: item.houseid || item.id || Math.random().toString(36).substr(2, 9)
          }
        })
      } catch (e) {
        console.error('获取未出租房屋失败：', e)
        this.$message.error('获取房屋信息失败')
        this.unRentHouseList = []
      }
    },
    
    handleHouseRowClick (row) {
      this.handleSelectHouse(row)
    },
    
    isHouseSelected(row) {
      if (!row || !row.id) return false
      return this.selectedHouse.id === row.id
    },
    
    handleSelectHouse (row) {
      if (!row) {
        this.$message.error('房屋数据为空')
        return
      }
      
      const houseid = row.id || row.houseid
      if (!houseid) {
        this.$message.error('房屋ID无效')
        return
      }
      
      this.selectedHouse = {
        id: houseid,
        address: row.address || '',
        roomNum: row.roomNum || '',
        price: row.price || ''
      }
      
      this.formData.address = row.address || ''
      this.formData.roomNum = row.roomNum || ''
      this.formData.price = row.price || ''
      
      this.$message.success(`已选中房屋：${row.address || ''} - ${row.roomNum || ''}`)
    },
    
    resetHouseSearch () {
      this.houseSearch = { address: '', roomNum: '' }
      this.getUnRentHouseList()
      this.selectedHouse = { id: null, address: '', roomNum: '', price: '' }
      this.formData.address = ''
      this.formData.roomNum = ''
      this.formData.price = ''
    },

    // ===================== 租户相关方法 =====================
    async getTenantList () {
      try {
        const res = await tenantApi.getTenantListByCondition(this.tenantSearch)
        
        let tenantData = []
        if (Array.isArray(res.data)) {
          tenantData = res.data
        } else if (res.data && Array.isArray(res.data.data)) {
          tenantData = res.data.data
        } else if (res.data && res.data.records) {
          tenantData = res.data.records
        } else if (res.data && res.data.list) {
          tenantData = res.data.list
        }
        
        this.tenantList = tenantData.map(item => {
          if (item.id) return item
          return {
            ...item,
            id: item.tenantid || item.id || Math.random().toString(36).substr(2, 9)
          }
        })
      } catch (e) {
        console.error('获取租户列表失败：', e)
        this.$message.error('获取租户信息失败')
        this.tenantList = []
      }
    },
    
    handleTenantRowClick (row) {
      this.handleSelectTenant(row)
    },
    
    isTenantSelected(row) {
      if (!row || !row.id) return false
      return this.selectedTenant.id === row.id
    },
    
    handleSelectTenant (row) {
      if (!row) {
        this.$message.error('租户数据为空')
        return
      }
      
      const tenantid = row.id
      if (!tenantid) {
        this.$message.error('租户ID无效')
        return
      }
      
      this.selectedTenant = {
        id: tenantid,
        tenantname: row.tenantname || '',
        contact: row.contact || '',
        contactphone: row.contactphone || ''
      }
      
      this.formData.tenantname = row.tenantname || ''
      this.formData.contact = row.contact || ''
      this.formData.contactphone = row.contactphone || ''
      
      this.$message.success(`已选中租户：${row.tenantname || ''}`)
    },
    
    resetTenantSearch () {
      this.tenantSearch = { tenantname: '' }
      this.getTenantList()
      this.selectedTenant = { id: null, tenantname: '', contact: '', contactphone: '' }
      this.formData.tenantname = ''
      this.formData.contact = ''
      this.formData.contactphone = ''
    },
    
    async addTenant () {
      try {
        await this.$refs.addTenantForm.validate()
        const res = await tenantApi.addTenant(this.newTenant)
        if (res.data.flag) {
          this.$message.success('新增租户成功')
          this.showAddTenantDialog = false
          this.newTenant = { tenantname: '', contact: '', contactphone: '' }
          this.getTenantList()
        } else {
          this.$message.warning('新增租户失败')
        }
      } catch (e) {
        console.error('新增租户失败：', e)
        this.$message.error('新增租户失败，请检查填写信息')
      }
    },

    // ===================== 日期变更处理 =====================
    handleStartDateChange() {
      this.calculateRentMonth()
      // 清空结束日期，防止出现结束日期早于开始日期的情况
      if (this.formData.enddate) {
        const startDate = new Date(this.formData.startdate)
        const endDate = new Date(this.formData.enddate)
        if (endDate < startDate) {
          this.formData.enddate = ''
          this.$message.warning('租赁结束日期已重置，请重新选择')
        }
      }
    },
    
    handleEndDateChange() {
      this.calculateRentMonth()
      // 自动触发表单验证
      if (this.$refs.leaseForm) {
        this.$refs.leaseForm.validateField('enddate')
      }
    },
    
    handlePaymentMethodChange() {
      this.calculateNextPayment()
    },
    
    handleCurrentRentalDateChange() {
      this.calculateNextPayment()
    },
    
    handleCurrentRentalAmountChange(value) {
      // 如果下次支付金额未被手动修改过，则同步更新
      if (!this.formData.isNextAmountModified && value) {
        this.formData.nextrentamount = value
      }
      this.calculateNextPayment()
    },
    
    handleNextRentalAmountChange() {
      // 标记下次支付金额已被手动修改
      this.formData.isNextAmountModified = true
    },

    // ===================== 表单辅助方法 =====================
    // 计算租赁月数
    calculateRentMonth() {
      if (!this.formData.startdate || !this.formData.enddate) {
        this.formData.rentmounthnum = ''
        return
      }
      
      try {
        const startDate = new Date(this.formData.startdate)
        const endDate = new Date(this.formData.enddate)
        
        if (endDate <= startDate) {
          this.formData.rentmounthnum = '0'
          return
        }
        
        // 计算月份差
        let months = (endDate.getFullYear() - startDate.getFullYear()) * 12
        months += endDate.getMonth() - startDate.getMonth()
        
        // 如果结束日期的天数大于开始日期的天数，加一个月
        if (endDate.getDate() > startDate.getDate()) {
          months += 1
        }
        
        this.formData.rentmounthnum = months.toString()
      } catch (e) {
        console.error('计算租赁月数失败:', e)
        this.formData.rentmounthnum = ''
      }
    },
    
    // 根据支付方式设置下次支付日期和金额
    calculateNextPayment() {
      if (!this.canCalculateNextPayment) {
        return
      }
      
      try {
        const currentDate = new Date(this.formData.currentrentaldate)
        let nextDate = new Date(currentDate)
        
        // 根据支付方式计算下次支付日期
        switch (this.formData.rentalsituation) {
          case '月付':
            nextDate.setMonth(nextDate.getMonth() + 1)
            break
          case '季付':
            nextDate.setMonth(nextDate.getMonth() + 3)
            break
          case '半年付':
            nextDate.setMonth(nextDate.getMonth() + 6)
            break
          case '年付':
            nextDate.setFullYear(nextDate.getFullYear() + 1)
            break
          default:
            return
        }
        
        // 设置下次支付日期
        const year = nextDate.getFullYear()
        const month = String(nextDate.getMonth() + 1).padStart(2, '0')
        const day = String(nextDate.getDate()).padStart(2, '0')
        this.formData.nextrentpaydate = `${year}-${month}-${day}`
        
        // 如果下次支付金额未被手动修改过，则默认等于本次租金金额
        if (!this.formData.isNextAmountModified && this.formData.currentrentalamount) {
          this.formData.nextrentamount = this.formData.currentrentalamount
        }
      } catch (e) {
        console.error('计算下次支付信息失败:', e)
      }
    },

    // 限制结束日期不能早于开始日期
    disabledEndDate (time) {
      if (!this.formData.startdate) return false
      const startDate = new Date(this.formData.startdate)
      startDate.setHours(0, 0, 0, 0)
      return time.getTime() < startDate.getTime()
    },

    // ===================== 步骤切换 =====================
    toNextStep () {
      if (this.currentStep === 1) {
        if (!this.selectedHouse.id) {
          this.$message.warning('请先选择一套未出租的房屋')
          return
        }
      }
      if (this.currentStep === 2) {
        if (!this.selectedTenant.id) {
          this.$message.warning('请先选择一个租户')
          return
        }
      }
      this.currentStep++
    },
    
    toPrevStep () {
      this.currentStep--
    },

    // ===================== 提交租赁信息 =====================
    onSubmit () {
      this.$refs.leaseForm.validate(async (valid) => {
        if (valid) {
          try {
            // 在提交前计算下次支付信息
            this.calculateNextPayment()
            
            // 构建符合后端实体类的数据
            const leaseData = {
              houseid: this.selectedHouse.id,
              tenantid: this.selectedTenant.id,
              startdate: this.formData.startdate,
              enddate: this.formData.enddate,
              deposit: this.formData.deposit || '0',
              rentalsituation: this.formData.rentalsituation,
              rentmounthnum: this.formData.rentmounthnum ? parseInt(this.formData.rentmounthnum) : 0,
              currentrentaldate: this.formData.currentrentaldate,
              currentrentalamount: this.formData.currentrentalamount || '0',
              isfullypaid: this.formData.isfullypaid,
              arrears: this.formData.arrears || '0',
              nextrentpaydate: this.formData.nextrentpaydate,
              nextrentamount: this.formData.nextrentamount || '0',
              context: this.formData.context || '',
              isdelete: 0
            }
            
            console.log('提交的租赁数据:', leaseData)
            
            const res = await leaseApi.addleaseinfo(leaseData)
            if (res.data && res.data.flag) {
              this.$message.success('新增租赁信息成功！')
              this.resetFormData()
              this.dialog1.show = false
              this.$emit('update')
            } else {
              this.$message.warning((res.data && res.data.msg) || '新增租赁信息失败')
            }
          } catch (e) {
            console.error('提交租赁信息失败：', e)
            if (e.response && e.response.data) {
              console.error('错误详情:', e.response.data)
            }
            this.$message.error('新增租赁信息失败，请检查数据格式')
          }
        } else {
          this.$message.warning('请完善所有必填项后提交')
        }
      })
    },

    // ===================== 其他方法 =====================
    resetFormData () {
      this.currentStep = 1
      this.selectedHouse = { id: null, address: '', roomNum: '', price: '' }
      this.selectedTenant = { id: null, tenantname: '', contact: '', contactphone: '' }
      this.formData = {
        address: '',
        roomNum: '',
        price: '',
        tenantname: '',
        contact: '',
        contactphone: '',
        startdate: '',
        enddate: '',
        deposit: '',
        rentalsituation: '',
        rentmounthnum: '',
        currentrentaldate: '',
        currentrentalamount: '',
        isfullypaid: '是',
        arrears: '0',
        nextrentpaydate: '',
        nextrentamount: '',
        context: '',
        isNextAmountModified: false
      }
    },
    
    closeDialog (done) {
      this.resetFormData()
      done()
    },
    
    onCancal () {
      this.resetFormData()
      this.dialog1.show = false
    }
  }
}
</script>

<style scoped>
.dialog1 {
  width: 100%;
}
.step-content {
  padding: 10px 0;
  max-height: 70vh;
  overflow-y: auto;
}
.text_right {
  text-align: right;
  margin-top: 20px;
}
.step-content::-webkit-scrollbar {
  width: 6px;
}
.step-content::-webkit-scrollbar-thumb {
  background-color: #e6e6e6;
  border-radius: 3px;
}

/* 选中行的样式 */
.selected-row {
  background-color: #ecf5ff !important;
}
.selected-row td {
  background-color: #ecf5ff !important;
}

/* 表单行样式 */
.el-row {
  margin-bottom: 15px;
}
</style>